import Chip from '@mui/material/Chip';
import {
  getFileStatusLabel,
  getStatusChipColors,
} from '../../utils/fileStatus';

interface StatusChipProps {
  /** Numeric `filestatus` as returned by the connector. */
  fileStatus: number;
}

/** Colour-coded chip for a request's file status. */
const StatusChip = ({ fileStatus }: StatusChipProps) => {
  const label = getFileStatusLabel(fileStatus);
  const { bg, fg } = getStatusChipColors(label);

  return (
    <Chip
      size='small'
      label={label}
      sx={{ backgroundColor: bg, color: fg, width: '100%' }}
    />
  );
};

export default StatusChip;
